module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp13_8.c9db544a.png";